import React from 'react';
import { Grid } from 'semantic-ui-react';
import Fetch from '@/hooks/fetch';
import DataManagementPanelContainer from './DataManagementPanelContainer';
import DataManagementPanelHeader from './DataManagementPanelHeader';
import UnmanagedDataMessage from './UnmanagedDataMessage';
import DataManagementDictionaryCards from './DataManagementCards';
import Selectors from '../hooks/selectors';
import DatasetEvents from '../../hooks/events';

const DataManagementPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const {
    canRead,
    dictionaries,
    exists,
    hasDataModel,
    readErrors,
    readStatus,
    unmanagedData,
    unmanagedDataReasons,
  } = Selectors.useDataManagementPanel(category, code);
  const fetchData = DatasetEvents.useFetchDataset('dataManagement', { code });
  Fetch.useFetchByCode(fetchData, 'dataManagement', code, readStatus);

  return (
    <DataManagementPanelContainer
      canRead={canRead}
      category={category}
      code={code}
      exists={exists}
      readErrors={readErrors}
      readStatus={readStatus}
    >
      <div className="aridhia-dataset-data-management-panel-narrow">
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column>
              <DataManagementPanelHeader code={code} onChange={onChange} url={url} />
            </Grid.Column>
          </Grid.Row>
          {unmanagedData && (
            <Grid.Row columns="equal">
              <Grid.Column>
                <UnmanagedDataMessage reasons={unmanagedDataReasons} />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
        <Grid columns="equal">
          <Grid.Row>
            <Grid.Column>
              <DataManagementDictionaryCards
                category={category}
                code={code}
                dictionaries={dictionaries}
                hasDataModel={hasDataModel}
                itemsPerRow={1}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </DataManagementPanelContainer>
  );
};

export default DataManagementPanelNarrow;
